import { combineReducers } from 'redux';
import globalReducer from '../global/reducers';
import { reducer as formReducer } from 'redux-form/immutable';

import { connectRouter } from 'connected-react-router';

import { history } from './createStore';

const makeRootReducer = asyncReducers =>
    combineReducers({
        router: connectRouter(history),
        global: globalReducer,
        form: formReducer,
        ...asyncReducers,
    });

export const injectReducer = (store, { key, reducer }) => {
    store.asyncReducers[key] = reducer;
    store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;
